/* eslint-disable jsx-a11y/anchor-has-content */
import { Product } from '@mc/api'
import {
  COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE,
  trackCollapsedPaintedDoorV2Viewed,
  trackCollapsedPaintedDoorViewed,
  trackI18nPricingT3Viewed,
} from '@mc/checkout'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'
import { TrackingContainer } from '@mc/visibility'

import i18nInstance from 'i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetPricingSectionProps = {
  isCheckoutPage?: boolean
  annualPass?: Product
  isEntryPaintedDoorVariant?: boolean
}

const onPricingSectionPriceVisible = () => {
  trackCollapsedPaintedDoorViewed()
  trackCollapsedPaintedDoorV2Viewed()
  trackI18nPricingT3Viewed()
}

export const getPricingSection: (props: GetPricingSectionProps) => Section = ({
  isCheckoutPage,
  annualPass,
  isEntryPaintedDoorVariant,
}: GetPricingSectionProps) => ({
  title: t('faq.pricing.title'),
  questions: [
    {
      title: t('faq.pricing.question1'),
      uuid: 'faq.pricing.question1',
      answer: (
        <TrackingContainer onFirstVisible={onPricingSectionPriceVisible}>
          <Trans
            i18nKey={
              isEntryPaintedDoorVariant
                ? `${COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE}:faq.pricing.answer1.string`
                : 'faq.pricing.answer1'
            }
            values={{ price: annualPass?.price }}
            ns='@mc/next'
          >
            <p className='mc-opacity--hinted'>
              <a href={paths.checkout} className='mc-text--link' />
            </p>
          </Trans>
        </TrackingContainer>
      ),
      hide: !annualPass?.price || isCheckoutPage,
    },
    {
      title: t('faq.pricing.question2'),
      uuid: 'faq.pricing.question2',
      answer: (
        <Trans i18nKey='faq.pricing.answer2' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.helpCenter} />
          </p>
        </Trans>
      ),
    },
    {
      title: t('faq.pricing.question3'),
      uuid: 'faq.pricing.question3.string',
      answer: (
        <Trans i18nKey='faq.pricing.answer3' ns='@mc/next'>
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.supportGetRefund} />
          </p>
        </Trans>
      ),
    },
    {
      title: t('faq.pricing.question4'),
      uuid: 'faq.pricing.question4.string',
      answer: (
        <Trans i18nKey='faq.pricing.answer4' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted'>
            <a href={paths.helpCenter} className='mc-text--link' />
          </p>
        </Trans>
      ),
    },
  ],
})
